<template>
  <div>
    <v-form ref="form" data-vv-scope="form1" lazy-validation>
      <v-container>
        
       <!--{{ orarioScelto }}-->
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- <center>
              <v-img
                max-height="150"
                max-width="250"
                src="../assets/Easy_CheckIn.png"
              ></v-img>
            </center>-->

            <v-card>
              <v-card-text>
                <span
                  class="text-body-1 text-justify font-weight-bold"
                  v-html="$t('testo_intro')"
                ></span> </v-card-text
            ></v-card>

            <br />
            <v-card>
              <!--<v-toolbar flat>
                <v-toolbar-title>
                  <span class="subheading">
                    {{ $t("domandaOraArrivo") }}
                  </span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon>mdi-chat-question</v-icon>
                </v-btn>
              </v-toolbar>-->
              <v-card-text>
                <p class="text-h6">{{ $t('domandaOraArrivo') }}</p>
                <v-select
            v-model="riepilogo.OraArrivo"
            :items="orarioDisponibile"
            chips
            outlined
          ></v-select>
                <!--<v-slider
                  v-model="orarioScelto"
                  :tick-labels="orarioDisponibile"
                  :max="16"
                  step="1"
                  ticks="always"
                  tick-size="8"
                  thumb-label="always"
                >
                  <template v-slot:thumb-label="{ value }">
                    {{
                      satisfactionEmojis[Math.min(Math.floor(value / 17), 9)]
                    }}
                  </template>
                  <template v-slot:label=""> </template>
                </v-slider>-->
              </v-card-text>
            </v-card>
            <!--<v-alert color="#2A3B4D" dark icon="mdi-chat-question" dense>
              <br />

              <date-picker
                v-model="riepilogo.OraArrivo"
                format="hh:mm a"
                value-type="format"
                type="time"
                placeholder="hh:mm a"
                :minute-step="30"
              ></date-picker>
            </v-alert>-->
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
//import DatePicker from "vue2-datepicker";
//import "vue2-datepicker/index.css";

export default {
  name: "OraArrivo",
  components: {
    //DatePicker
  },
  props: {
    tipo: String,
  },

  data: () => ({
    sesso: ["M", "F"],
    satisfactionEmojis: ["🏠"],
    orarioScelto: "",
    orarioDisponibile: [
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30",
      "19:00",
      "19:30",
      "20:00",
      "20:30",
      "21:00",
      "21:30",
      "22:00",
    ],
  }),
  watch: {
    orarioScelto(NewValue) {
      this.riepilogo.OraArrivo = this.orarioDisponibile[NewValue];
      //alert(NewValue + "-" + oldValue); //this.$vuetify.theme.dark = newValue;
    },
  },
  computed: {
    tipodoc() {
      return [this.$t("passaporto"), this.$t("cartaid")];
    },
    riepilogo: {
      get() {
        return this.$store.state.riepilogo;
      },
      set(value) {
        // this.$store.commit('updateMessage', value)
        alert(value);
      },
    },
    nazioni: {
      get() {
        return this.$store.state.nazioni;
      },
      set(value) {
        // this.$store.commit('updateMessage', value)
        alert(value);
      },
    },
  },
};
</script>
